module.exports = __webpack_public_path__ + "b215d5a0bb077810fc05680f8b3a0121.png";